import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { zh_TW,en_US,NzI18nService } from 'ng-zorro-antd/i18n';
@Component({
  selector: 'app-lang',
  templateUrl: './lang.component.html',
  styleUrls: ['./lang.component.css']
})
export class LangComponent implements OnInit {
  lang = localStorage.getItem('lang')  ||  'en'
  constructor( private translate: TranslateService,private i18n: NzI18nService) {
    // Initialize language on component creation
    // Handle both old 'zh' and new 'zh-HK' values for backward compatibility
    if (this.lang === 'zh-HK' || this.lang === 'zh') {
      this.lang = 'zh-HK'; // Update to new value
      this.translate.setDefaultLang('zh-HK');
      this.translate.use('zh-HK');
      this.i18n.setLocale(zh_TW);
      localStorage.setItem('lang', 'zh-HK'); // Update localStorage to new value
    } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
      this.i18n.setLocale(en_US);
    }
  }

  ngOnInit(): void {
  }

  setLang(type: string): void {
    if (type == 'en') {
      this.lang = 'en';
      this.translate.setDefaultLang('en');
      this.translate.use('en');
      localStorage.setItem('lang',"en")
      this.i18n.setLocale(en_US);
    } else {
      this.lang = 'zh-HK';
      this.translate.setDefaultLang('zh-HK');
      this.translate.use('zh-HK');
      localStorage.setItem('lang',"zh-HK")
      this.i18n.setLocale(zh_TW);
    }
  }
}
